
export function logValue(x: number, x0: number, x1: number, y0: number, y1: number): number {
    let minv = Math.log(y0);
    let maxv = Math.log(y1);
    return Math.exp(minv + ((maxv - minv) / (x1 - x0)) * (x - x0));
}

export function invLogValue(v: number, x0: number, x1: number, y0: number, y1: number): number {
    let minv = Math.log(y0);
    let maxv = Math.log(y1);
    return (Math.log(v) - minv) / ((maxv - minv) / (x1 - x0)) + x0;
}
